export default {
  STABLE_SCROLL: 'stableScroll',
  STOP_SCROLLING: 'stopScrolling',
  MATERIAL_EVENT: 'materialEvent',
  SECTION_EVENT: 'sectionEvent'
};
